import {
  QuantityActions,
  QuantityActionTypes,
} from '@ordersnproducts/modules/order-builder/modules/specification/actions/quantity.actions';

export interface QuantityState {
  value: number;
}

export const initialState: QuantityState = {
  value: null,
};

export function quantityReducer(state = initialState, action: QuantityActions): QuantityState {
  switch (action.type) {
    case QuantityActionTypes.QUANTITY_CHANGED: {
      return {
        ...state,
        value: action.payload,
      } as QuantityState;
    }
    case QuantityActionTypes.RESET: {
      return {
        ...initialState,
      } as QuantityState;
    }
    default: {
      return state;
    }
  }
}
